'use client';

import Image from 'next/image';
import Link from 'next/link';
import {trackContributionModuleClicked} from 'iq-companies/tracking';

// Same illustrated-banner shape as Takehomes' right-rail share card
// (iq-takehomes/components/share_take_home_banner.tsx) — image panel on top, content below —
// reusing the same existing asset. Panel background/border stay on this app's gray-* scale
// (not Takehomes' iq-grey-light) to match the rest of /companies.
export function ContributionModule() {
  return (
    <div className='flex flex-col overflow-hidden rounded-xl border border-gray-200 bg-white'>
      <div className='flex items-end justify-center bg-gray-50 px-6 pt-10'>
        <Image
          src='/img/felix-with-laptop.png'
          alt='Felix with laptop'
          width={220}
          height={185}
          className='object-contain'
          loading='eager'
        />
      </div>
      <div className='p-6'>
        <h2 className='mb-1 text-lg font-bold text-gray-900'>Just interviewed?</h2>
        <p className='mb-4 text-sm text-gray-600'>
          Help others land the job. All submissions are anonymous and reviewed before publishing.
        </p>
        <Link
          href='/submit-experience'
          onClick={() => void trackContributionModuleClicked()}
          className='block rounded-lg bg-iq-orange px-4 py-2.5 text-center text-sm font-semibold text-white transition-opacity hover:opacity-90'>
          Share your experience
        </Link>
      </div>
    </div>
  );
}
